import { registroContrato } from '@core/util/mockTourUtils';
import { excluirAlert, simpleAlert } from 'app/services/alerts';
import { contratoApi } from 'app/services/api/contratoApi';
import { fechamentoPeriodoApi } from 'app/services/api/fechamentoPeriodoApi';
import { pendenciasCobrancaApi } from 'app/services/api/pendenciasCobrancaApi';
import { generateActionTypes, generateDefaultActions } from 'app/store/defaultReducer';
import { eventReactGA } from 'app/utils/analyticsUtil';
import moment from 'moment';
import { prepararServicoFiscalParaSalvar } from 'app/main/venda/components/VendaProdutoServico/cadastro/servicoFiscalVendaUtils';
import { ContratosInitState } from '.';

const CONTRATO = 'Contrato';
const CONTRATOS = '[CONTRATOS]';
const SET_FILTRO_AVANCADO = `${CONTRATOS}_SET_FILTRO_AVANCADO`;
const OPEN_RESCISAO_CONTRATO = `${CONTRATOS}_OPEN_RESCISAO_CONTRATO`;
const CLOSE_RESCISAO_CONTRATO = `${CONTRATOS}_CLOSE_RESCISAO_CONTRATO`;
const BUSCAR_SOMATORIO_FILTRO = `${CONTRATOS}_BUSCAR_SOMATORIO_FILTRO`;
const VISUALIZAR_MODAL_PENDENCIAS = `${CONTRATOS}_VISUALIZAR_MODAL_PENDENCIAS`;
const SET_PENDENCIAS = `${CONTRATOS}_SET_PENDENCIAS`;
const CLEAR_FILTRO = `${CONTRATOS}_CLEAR_FILTRO`;

const initContratos = {};

const types = generateActionTypes(CONTRATOS);

export const ContratoTypes = {
  ...types,
  SET_FILTRO_AVANCADO,
  OPEN_RESCISAO_CONTRATO,
  CLOSE_RESCISAO_CONTRATO,
  BUSCAR_SOMATORIO_FILTRO,
  VISUALIZAR_MODAL_PENDENCIAS,
  SET_PENDENCIAS,
  CLEAR_FILTRO,
};

const defaultActions = generateDefaultActions(ContratoTypes);

const carregarRegistros = async (dispatch, queryParams = {}, filtroAvancado = {}) => {
  try {
    dispatch(ContratoAction.setCarregandoRegistros(true));
    const filtro = {
      ...queryParams,
      ...filtroAvancado,
      situacao: filtroAvancado.situacao === 'TODAS' ? undefined : filtroAvancado.situacao,
      clienteId: filtroAvancado.cliente?.id,
      servicoId: filtroAvancado.servico?.id,
      categoriaId: filtroAvancado.categoria?.id,
    };
    const resp = await contratoApi().buscar(filtro);
    dispatch(ContratoAction.buscar(resp.data));
    dispatch(ContratoAction.setCurrentPage(queryParams.page));
    dispatch(ContratoAction.setPageSize(queryParams.size));
    await buscarSomatorioFiltro(dispatch, filtro);
    dispatch(ContratoAction.limparSelecao());
  } catch (error) {
    dispatch(ContratoAction.erro(error?.response?.data?.message));
  } finally {
    dispatch(ContratoAction.setCarregandoRegistros(false));
  }
};

async function buscarTour(dispatch) {
  dispatch(ContratoAction.buscar(registroContrato));
  dispatch(ContratoAction.setCurrentPage(registroContrato.page));
  dispatch(ContratoAction.setPageSize(registroContrato.size));
}

const buscarSomatorioFiltro = async (dispatch, filtro) => {
  try {
    const response = await contratoApi().buscarSomatorioFiltro(filtro);

    dispatch({ type: BUSCAR_SOMATORIO_FILTRO, payload: response.data });
  } catch (error) {
    dispatch(ContratoAction.erro(error?.response?.data?.message));
  }
};

const requestVisualizar = async (dispatch, id) => {
  try {
    dispatch(ContratoAction.carregandoRegistro(true));
    const response = await contratoApi().buscarPorId(id, true);
    dispatch(ContratoAction.visualizar(response.data));
  } catch (error) {
    dispatch(ContratoAction.erro(error?.response?.data?.message));
  } finally {
    dispatch(ContratoAction.carregandoRegistro(false));
  }
};

const requestEditar = async (dispatch, contrato) => {
  const response = await fechamentoPeriodoApi.buscarUltimoPeriodo('RECEBIMENTOS_VENDAS', contrato.dataVigenciaInicial);
  if (response.data && response.data.bloquearAnteriores) {
    if (
      moment(contrato.dataVigenciaInicial).isSameOrBefore(response.data.periodo) &&
      response.data.funcionalidades.includes('RECEBIMENTOS_VENDAS')
    ) {
      ContratoAction.fecharModalCadastro(dispatch);
      throw dispatch(
        ContratoAction.erro('Não é possível lançar e editar contratos dentro do período já fechado no sistema.')
      );
    }
  }

  try {
    dispatch(ContratoAction.carregandoRegistro(true));
    const response = await contratoApi().buscarPorId(contrato.id);

    dispatch(ContratoAction.editar(response.data));
  } catch (error) {
    dispatch(ContratoAction.erro(error?.response?.data?.message));
  } finally {
    dispatch(ContratoAction.carregandoRegistro(false));
  }
};

const requestExcluir = async (dispatch, idsSelecionados, params, tipoSelecao, filtroAvancado) => {
  excluirAlert({
    confirmar: async () => {
      dispatch(ContratoAction.setCarregandoRegistros(true));
      try {
        eventReactGA(CONTRATO, 'Excluir contrato');
        await contratoApi().excluir({
          ids: idsSelecionados,
          q: params?.q,
          tipoSelecao,
          ...filtroAvancado,
          situacao: filtroAvancado.situacao === 'TODAS' ? undefined : filtroAvancado.situacao,
          clienteId: filtroAvancado.cliente?.id,
          servicoId: filtroAvancado.servico?.id,
          categoriaId: filtroAvancado.categoria?.id,
        });

        dispatch(ContratoAction.sucesso('Contrato excluído com sucesso'));
        dispatch(ContratoAction.limparSelecao());
        carregarRegistros(dispatch, params, filtroAvancado);
      } catch (error) {
        dispatch(ContratoAction.erro(error?.response?.data?.message));
      } finally {
        dispatch(ContratoAction.setCarregandoRegistros(false));
      }
    },
  });
};

const setFiltroAvancado = (dispatch, filtroAvancado) => {
  dispatch({ type: SET_FILTRO_AVANCADO, payload: filtroAvancado });
};

const openModalRescisaoContrato = (dispatch, contrato) => {
  eventReactGA(CONTRATO, 'Rescindir contrato');
  dispatch({ type: OPEN_RESCISAO_CONTRATO, payload: contrato });
};

const closeModalRescisaoContrato = (dispatch) => {
  dispatch({ type: CLOSE_RESCISAO_CONTRATO });
};

const rescindirContrato = async (dispatch, rescisao, contrato, requestParams, filtroAvancado) => {
  const _rescisao = JSON.parse(JSON.stringify(rescisao));
  try {
    dispatch(ContratoAction.carregandoRegistro(true));

    await contratoApi().rescindirContrato(_rescisao, contrato.id);
    dispatch(ContratoAction.sucesso('Contrato rescindido com sucesso'));

    closeModalRescisaoContrato(dispatch);

    dispatch(ContratoAction.limparSelecao());
    carregarRegistros(dispatch, requestParams, filtroAvancado);
  } catch (error) {
    dispatch(ContratoAction.erro(error?.response?.data?.message, contrato));
  } finally {
    dispatch(ContratoAction.carregandoRegistro(false));
  }
};

const verificarPendencias = async (dispatch, contrato) => {
  try {
    dispatch(ContratoAction.carregandoRegistro(true));

    const resp = await pendenciasCobrancaApi().buscar(contrato.formaCobranca, contrato.cliente?.id);

    dispatch(ContratoAction.carregandoRegistro(false));

    return resp.data;
  } catch (error) {
    dispatch(ContratoAction.erro(error?.response?.data?.message, contrato));
  }
};

const onSubmit = async (dispatch, contrato, requestParams) => {
  const pendencias = await verificarPendencias(dispatch, contrato);

  // Se houverem pendências para gerar cobrança, exibe o modal, senão chama o método de submit.
  if (pendencias?.length > 0) {
    dispatch({ type: SET_PENDENCIAS, payload: pendencias });

    showHideModalPendencia(dispatch, true);

    dispatch(ContratoAction.carregandoRegistro(false));
  } else {
    const _contrato = JSON.parse(JSON.stringify(contrato));

    try {
      dispatch(ContratoAction.carregandoRegistro(true));

      _contrato.clienteId = _contrato.cliente?.id;
      _contrato.vendedorId = _contrato.vendedor?.id;
      _contrato.imovelId = _contrato.imovel?.id;

      delete _contrato._exigeImovel;

      _contrato.categorias.forEach((categoria) => {
        categoria.classeId = categoria.classe.id;
      });

      _contrato.servicos.forEach((servicoItem) => {
        servicoItem.servicoId = servicoItem.servico?.id;
        servicoItem.servicoFiscal = prepararServicoFiscalParaSalvar(servicoItem.servicoFiscal);
      });

      if (!_contrato.envioAutomaticoCobranca) {
        delete _contrato.emailsCliente;
        _contrato.enviarCobrancaEmail = false;
        _contrato.enviarNotaFiscalEmail = false;
      }

      if (_contrato.adesao?.cobrarAdesao) {
        _contrato.adesao.servicoId = _contrato.adesao?.servico?.id;
        _contrato.adesao.categoriaId = _contrato.adesao?.categoria?.id;

        _contrato.adesao.servicoFiscal = prepararServicoFiscalParaSalvar(_contrato.adesao.servicoFiscal);
      } else {
        delete _contrato.adesao;
      }

      let resp;
      let msgSucesso;
      if (_contrato.id) {
        eventReactGA(CONTRATO, 'Atualizar contrato');
        resp = await contratoApi().atualizar(_contrato.id, _contrato);
        msgSucesso = 'Contrato editado com sucesso';
      } else {
        eventReactGA(CONTRATO, 'Cadastrar contrato');
        resp = await contratoApi().cadastrar(_contrato);
        msgSucesso = 'Contrato salvo com sucesso';
      }

      // RNE-512
      if (resp.data.processamentoCobrancaPendente) {
        dispatch(ContratoAction.carregandoRegistro(false));

        await simpleAlert({
          opcoes: {
            title:
              'Algumas cobranças precisaram ser geradas imediatamente. Lembre-se de fazer o processamento no banco hoje.',
          },
        });

        // FIXME: Ao exibir o simpleAlert, a mensagem de sucesso e o loading na tela não são renderizados.
        // Buscar uma forma pra corrigir esse problema que não envolva o uso do setTimeout.
        setTimeout(async () => {
          dispatch(ContratoAction.carregandoRegistro(true));

          await afterSubmit(dispatch, msgSucesso, contrato, requestParams);

          dispatch(ContratoAction.carregandoRegistro(false));
        }, 0);
      } else {
        afterSubmit(dispatch, msgSucesso, contrato, requestParams);
      }
    } catch (error) {
      if (error?.response?.data?.errorKey === 'erro.atualizar.contrato.unificado') {
        simpleAlert({
          opcoes: {
            title: error.response?.data?.message,
          },
        });
      } else {
        dispatch(ContratoAction.erro(error?.response?.data?.message, _contrato));
      }
    } finally {
      dispatch(ContratoAction.carregandoRegistro(false));
    }
  }
};

const afterSubmit = async (dispatch, msgSucesso, contrato, requestParams) => {
  dispatch(ContratoAction.sucesso(msgSucesso, contrato));

  dispatch(ContratoAction.limparSelecao());

  dispatch({ type: CLEAR_FILTRO });

  carregarRegistros(dispatch, requestParams, ContratosInitState.filtroAvancado);
};

const showHideModalPendencia = (dispatch, show) => {
  dispatch({ type: VISUALIZAR_MODAL_PENDENCIAS, payload: show });
};

const calcularVigenciaFinal = (dataInicio, vigenciaIndeterminada, periodicidade) => {
  let dataVigenciaInicial = dataInicio?.toDate();
  let dataVigenciaFinal;
  if (dataInicio && vigenciaIndeterminada && periodicidade === 'ANUAL') {
    dataVigenciaFinal = dataVigenciaInicial.setMonth(dataVigenciaInicial.getMonth() + 360);
  } else if (dataInicio && periodicidade === 'ANUAL') {
    dataVigenciaFinal = dataVigenciaInicial.setMonth(dataVigenciaInicial.getMonth() + 12);
  } else if (dataInicio && vigenciaIndeterminada && periodicidade === 'MENSAL') {
    dataVigenciaFinal = dataVigenciaInicial.setMonth(dataVigenciaInicial.getMonth() + 120);
  }
  return moment(dataVigenciaFinal);
};

const calcularPeriodoVigencia = (dataInicio, dataFim) => {
  let meses = 0;
  let dias = 0;

  // Verifica se o mês da vigência inicial é cheio
  const isMesCheioVigenciaInicial = dataInicio.date() === 1;

  // Verifica se o mês da vigência final é cheio
  const isMesCheioVigenciaFinal = dataFim.date() === dataFim.daysInMonth();

  // Calcula quantidade de meses cheios
  const anos = dataFim.year() - dataInicio.year();
  meses = anos * 12 + (dataFim.month() - dataInicio.month() + 1);

  if (!isMesCheioVigenciaInicial) {
    meses -= 1;
  }
  if (!isMesCheioVigenciaFinal) {
    meses -= 1;
  }

  // Calcula quantidade de dias
  if (dataInicio.month() === dataFim.month() && meses <= 0) {
    dias = dataFim.date() - dataInicio.date() + 1;
  } else {
    if (!isMesCheioVigenciaInicial) {
      dias = dataInicio.daysInMonth() - dataInicio.date() + 1;
    }
    if (!isMesCheioVigenciaFinal) {
      dias += dataFim.date();
    }
  }

  const textoMeses = meses > 0 ? `${meses} ${meses === 1 ? 'mês' : 'meses'}` : '';
  const textoDias = dias > 0 ? `${dias} dias` : '';

  return `${textoMeses} ${meses > 0 && dias > 0 ? ' e ' : ''} ${textoDias}`;
};

// RNE-1298: o imóvel relacionado só é exigido no cadastro e exibido na visualização quando
// o código de operação IBS/CBS da empresa é um destes.
const CODIGOS_OPERACAO_IBS_CBS_COM_IMOVEL = ['020101', '020201', '020301'];

const exigeImovelRelacionado = (codigoOperacaoIbsCbs) =>
  !!codigoOperacaoIbsCbs && CODIGOS_OPERACAO_IBS_CBS_COM_IMOVEL.includes(String(codigoOperacaoIbsCbs).padStart(6, '0'));

export const ContratoUtil = {
  calcularPeriodoVigencia,
  calcularVigenciaFinal,
  exigeImovelRelacionado,
};

export const ContratoAction = {
  ...defaultActions,
  cadastrar: (init = initContratos) => defaultActions.cadastrar(init),
  carregarRegistros,
  buscarSomatorioFiltro,
  requestVisualizar,
  requestEditar,
  requestExcluir,
  setFiltroAvancado,
  openModalRescisaoContrato,
  closeModalRescisaoContrato,
  rescindirContrato,
  onSubmit,
  showHideModalPendencia,
  buscarTour,
};
